module.exports = __webpack_public_path__ + "static/media/orulunk.50650be2.png";